import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_RESPONSE,
  FETCH_PRODUCTS_FAILURE,
  ProductState,
  ProductActionTypes, FETCH_PRODUCT_REQUEST, FETCH_PRODUCT_FAILURE, FETCH_PRODUCT_RESPONSE,
} from '../types/Product';

const initialState: ProductState = {
  products: [],
  product: null,
  isFetchingProducts: false,
  fetchingProductsFailed: false,
};

const productReducer = (
  state = initialState,
  action: ProductActionTypes,
): ProductState => {
  switch (action.type) {
    case FETCH_PRODUCT_REQUEST:
      return {
        ...state,
        product: null,
      };
    case FETCH_PRODUCT_RESPONSE:
      return {
        ...state,
        product: action.payload || null,
      };
    case FETCH_PRODUCT_FAILURE:
      return {
        ...state,
        product: null,
      };
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        products: [],
        isFetchingProducts: true,
        fetchingProductsFailed: false,
      };
    case FETCH_PRODUCTS_RESPONSE:
      return {
        ...state,
        products: action.payload || [],
        isFetchingProducts: false,
        fetchingProductsFailed: false,
      };
    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        products: [],
        isFetchingProducts: false,
        fetchingProductsFailed: true,
      };
    default:
      return state;
  }
};

export default productReducer;
